module.exports = __webpack_public_path__ + "models/scene5.0514d10.txt";